export default __webpack_public_path__ + "static/media/RobotoSlab-VariableFont_wght.27a558ea.ttf";